/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Filter values use the same shapes as the Invoice Entry / Approval filters (FilterAccordion
// selections + a date range), so they survive opening a detail screen and coming back.
export interface IavFilters {
  category: string;
  company: any[];
  division: any[];
  assignee: any[];
  status: any[];
  sorting: any[];
  dateType: any[];
  dateRange: { from?: string; to?: string } | null;
  searchCategory: string;
  searchValue: string;
}

export interface IavState {
  queueList: any[];
  queueTotal: number;
  queuePage: number;
  selectedInvoice: any | null;
  revokeReasons: any[];
  filters: IavFilters;
  filterOptions: { company: any[]; division: any[]; assignee: any[] };
  isLoading: boolean;
  rejectModalOpen: boolean;
  reassignModalOpen: boolean;
}

const initialFilters: IavFilters = {
  category: "STAMP_SIGN_REVIEW",
  company: [],
  division: [],
  assignee: [],
  status: [],
  sorting: [],
  dateType: [],
  dateRange: null,
  searchCategory: "invoice_number",
  searchValue: "",
};

const iavSlice = createSlice({
  name: "iav",
  initialState: {
    queueList: [],
    queueTotal: 0,
    queuePage: 1,
    selectedInvoice: null,
    revokeReasons: [],
    filters: initialFilters,
    filterOptions: { company: [], division: [], assignee: [] },
    isLoading: false,
    rejectModalOpen: false,
    reassignModalOpen: false,
  } as IavState,
  reducers: {
    setQueueList(state, action: PayloadAction<{ items: any[]; total: number }>) {
      state.queueList = action.payload.items;
      state.queueTotal = action.payload.total;
    },
    setQueuePage(state, action: PayloadAction<number>) {
      state.queuePage = action.payload;
    },
    setSelectedInvoice(state, action: PayloadAction<any>) {
      state.selectedInvoice = action.payload;
    },
    setRevokeReasons(state, action: PayloadAction<any[]>) {
      state.revokeReasons = action.payload;
    },
    setFilters(state, action: PayloadAction<Partial<IavFilters>>) {
      state.filters = { ...state.filters, ...action.payload };
    },
    // Clears every filter except the selected category and search category
    resetFilters(state) {
      state.filters = {
        ...initialFilters,
        category: state.filters.category,
        searchCategory: state.filters.searchCategory,
      };
    },
    setFilterOptions(state, action: PayloadAction<Partial<IavState["filterOptions"]>>) {
      state.filterOptions = { ...state.filterOptions, ...action.payload };
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setRejectModalOpen(state, action: PayloadAction<boolean>) {
      state.rejectModalOpen = action.payload;
    },
    setReassignModalOpen(state, action: PayloadAction<boolean>) {
      state.reassignModalOpen = action.payload;
    },
  },
});

export const iavActions = iavSlice.actions;
export { iavSlice };
